import { Component } from "../../helpers/compiler";

declare let ScrollMagic: any;
declare let TweenMax: any;
declare let Linear: any;
export const ScrollMagicController = new ScrollMagic.Controller();

@Component({ className: 'js-magic-scroll-slide-horizontal' })
export class MagicScrollSlideHorizontalComponent {
    private scenes: any[] = [];

    constructor(private element: HTMLElement) {
        const hook = Number.parseFloat(this.element.getAttribute('data-magic-hook') || '0.5');
        const from = Number.parseFloat(this.element.getAttribute('data-magic-from') || '50');
        const to = Number.parseFloat(this.element.getAttribute('data-magic-to') || '-50');
        const fill = this.element.getAttribute('data-magic-fill') == 'true';
        const item = this.element.querySelector('.js-magic-slide-horizontal-item') || this.element;

        while (fill && item.textContent && item.textContent?.length < 150) {
            item.textContent = item.textContent + ' - ' + item.textContent
        }

        this.setScene(from, to, hook, item)
    }

    private setScene(from: number, to: number, hook: number, item: Element) {
        this.scenes.push(
            new ScrollMagic.Scene({
                triggerElement: this.element,
                triggerHook: hook,
                duration: window.innerHeight * 1.2
            })
                .setTween(
                    TweenMax.fromTo(
                        item,
                        1,
                        {
                            css: { translateX: from + '%' }
                        },
                        {
                            css: { translateX: to + '%' },
                            ease: Linear.easeNone,
                        }
                    )
                )
                .addTo(ScrollMagicController)
            // .addIndicators({
            //     name: "horizontal",
            //     colorStart: 'red',
            //     colorEnd: 'red',
            //     colorTrigger: 'red',
            // })
        );
    }
}
